"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import { APIDataSource } from "@/components/grid/data-source";
import QuestionSlot from "@/components/QuestionSlot.vue";
import { AccountSessionMixins } from "@/service/account-session";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import { Debounce } from "vue-debounce-decorator";
import DateFormat from "@/framework/timeformatter";
const kefu_new = require("@/assets/appImg/kefu_new.png");
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
import AddInprogressUsersDialog from "@/views/safemanagements/InprogressManager/dialogs/AddInprogressUsersDialog.vue";
let InprogressUser = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.kefuImg = kefu_new;
    this.empty_image = emptyImage;
    this.addLoading = false;
    this.hasPermission = false;
    this.mask = true;
    this.searchName = "";
    this.selectedItems = [];
    // 监管名额；
    this.quota = 0;
    this.usedQuota = 0;
    this.hasAvailableVd = false;
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v1/monitor/resource-bindings/USER")
    );
    this.expiredDate = null;
  }
  mounted() {
    return __async(this, null, function* () {
      this.mask = true;
      yield this.checkHasAvailableVd();
      yield this.checkPermissions();
    });
  }
  checkHasAvailableVd() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth.pro/v1/chat-check-vd`);
        if (response.data.hasAvailableVd) {
          this.hasAvailableVd = true;
        } else {
          this.hasAvailableVd = false;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  checkPermissions() {
    return __async(this, null, function* () {
      try {
        const sessionResponse = yield API.get(`api://base.auth.pro/v1/account/session`);
        const session = sessionResponse.data;
        let tag = session.marks.tags;
        if (tag.includes("SAFETY_MANAGER_EXPIRE")) {
          this.hasPermission = false;
          return;
        }
        if (tag.includes("SAFETY_MANAGER_TRIAL") || tag.includes("SAFETY_MANAGER_CHARGE")) {
          this.hasPermission = true;
          yield this.getQuota();
          yield this.checkDashboard();
          yield this.gridController.search();
        } else {
          this.hasPermission = false;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.mask = false;
      }
    });
  }
  checkDashboard() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth.pro/v1/accounts/dashboard`
        );
        if (response.data.regulationExpireTime) {
          this.expiredDate = response.data.regulationExpireTime;
        }
      } catch (error) {
      }
    });
  }
  //日期类型转换
  format_date(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatterDay(DateFormat.check(time));
    }
  }
  //日期类型转换
  format_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatter(DateFormat.check(time));
    }
  }
  getQuota() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v1/regulation-quota-statistics`);
        this.quota = response.data.totalQuota;
        this.usedQuota = response.data.usedQuota;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleSearch() {
    return __async(this, null, function* () {
      try {
        if (this.searchName && this.searchName !== "") {
          this.gridController.query.params = {
            search: `name=='${this.searchName}'`
          };
        } else {
          this.gridController.query.params = null;
        }
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleFileTransferLogStatus(row) {
    return __async(this, null, function* () {
      try {
        if (row.fileTransferLogStatus) {
          yield API.put(`api://base.auth/api/v1/monitor/resource-bindings/USER/file-transfer-records/${row.resourceId}/open`);
        } else {
          yield API.put(`api://base.auth/api/v1/monitor/resource-bindings/USER/file-transfer-records/${row.resourceId}/close`);
        }
      } catch (error) {
        row.fileTransferLogStatus = !row.fileTransferLogStatus;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  selectItems(selected) {
    this.selectedItems = [];
    for (const item of selected) {
      this.selectedItems.push(item);
    }
  }
  addMoreShops() {
    return __async(this, null, function* () {
      if (this.hasAvailableVd) {
        this.$router.push("/pay_additional_purchase");
      } else {
        this.$message.warning(this.$t("inprogress_shops.no_available_vd_tips"));
      }
    });
  }
  addUsers() {
    return __async(this, null, function* () {
      this.addLoading = true;
      let numData = {
        quota: this.quota,
        usedQuota: this.usedQuota
      };
      this._addInprogressUsersDialog.open(null, numData);
      this.$nextTick(() => {
        this.addLoading = false;
      });
    });
  }
  addInprogressUsers(users) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        for (const user of users.selectedUsers) {
          arr.push(user.id);
        }
        yield API.post(`api://base.auth/api/v1/monitor/resource-bindings/USER`, {
          resourceIds: arr
        });
        this.$message.success(this.$t("inprogress_users.add_supervise_success"));
        yield this.gridController.search();
        yield this.getQuota();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openMoreRules() {
    return __async(this, null, function* () {
    });
  }
  useTutorial() {
    return __async(this, null, function* () {
    });
  }
  freeExperience() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.confirm(this.$t("inprogress_users.free_experience_tips_content"), this.$t("inprogress_shops.free_experience_title"), {
          confirmButtonText: this.$t("inprogress_shops.free_experience_confirm"),
          cancelButtonText: this.$t("inprogress_shops.free_experience_cancel"),
          roundButton: true,
          showConfirmButton: true,
          showCancelButton: true
        });
        let loading = this.$loading({
          lock: true,
          fullscreen: true,
          text: this.$t(
            "inprogress_shops.loading"
          ),
          customClass: "hard-loading",
          background: "rgba(0, 0, 0, 0.8)"
        });
        yield API.post(`api://base.auth/api/v1/regulation-trial-apply`);
        this.hasPermission = true;
        let numData = {
          quota: 1,
          usedQuota: 0
        };
        this._addInprogressUsersDialog.open(null, numData);
        loading.close();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  upgradeVip() {
    return __async(this, null, function* () {
      if (this.hasAvailableVd) {
        this.$router.push("/purchase_service");
      } else {
        this.$message.warning(this.$t("inprogress_shops.no_available_vd_tips"));
      }
    });
  }
  renewVip() {
    return __async(this, null, function* () {
      if (this.hasAvailableVd) {
        this.$router.push("/purchase_service?type=renew");
      } else {
        this.$message.warning(this.$t("inprogress_shops.no_available_vd_tips"));
      }
    });
  }
  viewOperation(row) {
    return __async(this, null, function* () {
      if (row.resourceType === "USER") {
        const fullpath = this.$router.resolve(`/midsafety?tab=monitor_log&userId=${row.resourceId}`);
        window.open(fullpath.href, "__blank");
      }
    });
  }
  closeSupervise(row) {
    return __async(this, null, function* () {
      try {
        const confirm = yield UiConfirm.confirm(this.$t("inprogress_shops.close_supervise_tips", { name: row.name }), this.$t("inprogress_shops.close_supervise_title"), {
          confirmButtonText: this.$t("inprogress_shops.close_supervise_confirm"),
          cancelButtonText: this.$t("inprogress_shops.close_supervise_cancel"),
          roundButton: true,
          showConfirmButton: true,
          showCancelButton: true
        });
        if (!confirm) {
          return;
        }
        let arr = [];
        arr.push(row.resourceId);
        yield API.put(`api://base.auth/api/v1/monitor/resource-bindings/USER/close`, {
          resourceIds: arr
        });
        this.$message.success(this.$t("inprogress_users.close_supervise_success"));
        yield this.gridController.search();
        yield this.getQuota();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("addInprogressUsersDialog")
], InprogressUser.prototype, "_addInprogressUsersDialog", 2);
__decorateClass([
  Debounce(400)
], InprogressUser.prototype, "handleSearch", 1);
__decorateClass([
  Debounce(400)
], InprogressUser.prototype, "handleFileTransferLogStatus", 1);
__decorateClass([
  Debounce(400)
], InprogressUser.prototype, "addInprogressUsers", 1);
__decorateClass([
  Debounce(400)
], InprogressUser.prototype, "upgradeVip", 1);
__decorateClass([
  Debounce(400)
], InprogressUser.prototype, "closeSupervise", 1);
InprogressUser = __decorateClass([
  Component({
    components: {
      UiGrid,
      QuestionSlot,
      AddInprogressUsersDialog
    }
  })
], InprogressUser);
export {
  InprogressUser as default
};
